import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import type {
  FaceItemModel,
  FilterSelectionMap,
} from '@fantaz/shared/data-access/models';
import { ChipGroup, FzChip } from '@fantaz/shared/ui/chip';

@Component({
  selector: 'fz-refinement-list',
  standalone: true,
  imports: [ChipGroup, FzChip],
  templateUrl: './refinement-list.html',
  styleUrls: ['./refinement-list.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'fz-refinement-list',
  },
})
export class RefinementList {
  scrollable = input<boolean>(false);
  items = input.required<FaceItemModel[]>();
  selected = input<string[]>();

  selectionChanged = output<string[]>();

  selection = computed(() => this.selected());

  /**
   * Mapped object of selected items, it is used to highlight the selected items
   * in the chip group. It is computed from the selected array.
   *
   * @type {FilterSelectionMap}
   */
  selectedMap = computed<FilterSelectionMap>(() => {
    const selected = this.selected();

    if (!selected) {
      return {};
    }

    return selected.reduce((acc, key) => {
      return {
        ...acc,
        [key]: true,
      };
    }, {} as FilterSelectionMap);
  });

  /**
   * Toggles the selection of a filter item.
   *
   * @param {string} key - The key of the filter item to toggle.
   */
  toggleSelection(key: string) {
    const selected = this.selected() || [];
    const isSelected = this.selectedMap()[key] || false;
    this.selectionChanged.emit(
      isSelected ? selected.filter((item) => item !== key) : [...selected, key],
    );
  }
}
